module.exports = __webpack_public_path__ + "static/media/feedback.2bada474.png";